import alertConfirm from '@/components/common/confirm'
import { getToken } from '@/util/getToken.js'
import Vue from 'vue'
import VueRouter from 'vue-router'
import check from '../plugins/check'
import { getViewWarehouseList } from '@/api/warehouse/warehouse.js'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

const routes = [
  {
    path: '/auth',
    name: 'auth',
    redirect: '/login',
    component: () => import('../views/login/index.vue'),
    meta: {
      selectFlag: false
    },
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import('../views/login/login.vue'),
        meta: {
          selectFlag: false
        }
      },
      {
        path: '/register',
        name: 'register',
        component: () => import('../views/login/register.vue'),
        meta: {
          selectFlag: false
        }
      },
      {
        path: '/collectTag',
        name: 'collectTag',
        component: () => import('../views/login/collectTag.vue'),
        meta: {
          selectFlag: false
        }
      },
      {
        path: '/getBackPass',
        name: 'getBackPass',
        component: () => import('../views/login/getBackPass.vue'),
        meta: {
          selectFlag: false
        }
      }
    ]
  },
  {
    path: '/build',
    name: 'build',
    component: () => import('../views/warehouse/build/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  {
    path: '/previewPlay',
    name: 'previewPlay',
    component: () => import('../views/preview/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: false,
      visibleShrinkUnfold: true
    }
  },
  {
    path: '/sharePreview',
    name: 'sharePreview',
    component: () => import('../views/preview/sharePreview.vue'),
    meta: {
      selectFlag: true,
      requireVip: false,
      visibleShrinkUnfold: true
    }
  },
  {
    path: '/remoteView',
    name: 'remoteView',
    component: () => import('../views/previewPlay/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  {
    path: '/infer',
    name: 'infer',
    component: () => import('../views/warehouse/infer/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  {
    path: '/warehouseMonitorSystem',
    name: 'warehouseMonitorSystem',
    component: () => import('../views/monitorSystem/warehouseMonitorSystem.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  {
    path: '/dataBoard',
    name: 'dataBoard',
    component: () => import('../views/dataBoard.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  {
    path: '/per',
    name: 'per',
    component: () => import('../views/person/index.vue'),
    redirect: '/person',
    children: [
      {
        path: '/person',
        name: 'person',
        component: () => import('../views/person/components/person.vue'),
        meta: {
          isBack: false,
          selectFlag: false,
          requireVip: false
        }
      },
      {
        path: '/myWarehouse',
        name: 'myWarehouse',
        component: () => import('../views/person/components/myWarehouse.vue'),
        meta: {
          isBack: false,
          selectFlag: false,
          requireVip: false
        }
      },
      {
        path: '/orderCenter',
        name: 'orderCenter',
        component: () => import('../views/person/components/orderCenter.vue'),
        meta: {
          isBack: false,
          selectFlag: false,
          requireVip: false
        }
      }
    ]
  },
  {
    path: '/setup',
    name: 'setup',
    component: () => import('../views/setup.vue'),
    meta: {
      selectFlag: false,
      requireVip: true
    }
  },
  {
    path: '/newShelf',
    name: 'newShelf',
    component: () => import('../views/monitorSystem/newShelf.vue'),
    meta: {
      selectFlag: false,
      requireVip: true
    }
  },
  {
    path: '/costIndex',
    name: 'costIndex',
    component: () => import('../views/cost/index.vue'),
    redirect: '/cost',
    children: [
      {
        path: '/cost',
        name: 'cost',
        component: () => import('../views/cost/cost.vue'),
        meta: {
          title: '费用主页',
          isBack: false,
          selectFlag: false,
          requireVip: true
        }
      },
      {
        path: '/recharge',
        name: 'recharge',
        component: () => import('../views/cost/recharge.vue'),
        meta: {
          title: '充值汇款',
          isBack: true,
          selectFlag: false,
          requireVip: true
        }
      },
      {
        path: '/rechargeRecord',
        name: 'rechargeRecord',
        component: () => import('../views/cost/rechargeRecord.vue'),
        meta: {
          title: '充值记录',
          isBack: false,
          selectFlag: false,
          requireVip: true
        }
      },
      {
        path: '/expense',
        name: 'expense',
        component: () => import('../views/cost/expense.vue'),
        meta: {
          title: '消费记录',
          isBack: false,
          selectFlag: false,
          requireVip: true
        }
      }
    ]
  },
  {
    path: '/sort',
    name: 'sort',
    component: () => import('../views/sort.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  {
    path: '/virtually',
    name: 'virtually',
    component: () => import('../views/virtually-World/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  {
    path: '/costCalculate',
    name: 'costCalculate',
    component: () => import('../views/costCalculate/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  {
    path: '/nestification',
    name: 'nestification',
    component: () => import('../views/nestification/index.vue'),
    meta: {
      selectFlag: true
    }
  },
  {
    path: '/collectGoods',
    name: 'collectGoods',
    component: () => import('../views/collectGoods/index.vue'),
    meta: {
      selectFlag: true,
      visibleCollectGoods: true
    }
  },
  {
    path: '/studentWarehouseBuild',
    name: 'studentWarehouseBuild',
    component: () => import('../views/warehouse/build/studentWarehouseBuild.vue'),
    meta: {
      selectFlag: true,
      requireVip: false
    }
  },
  {
    path: '/studentWarehousePreview',
    name: 'studentWarehousePreview',
    component: () => import('../views/preview/studentWarehousePreview.vue'),
    meta: {
      selectFlag: true,
      requireVip: false,
      visibleShrinkUnfold: true
    }
  },
  {
    path: '/educationTransferPage/createWarehouse',
    name: 'createWarehouse',
    component: () => import('../views/educationTransferPage/createWarehouse.vue'),
    meta: {
      selectFlag: true,
      requireVip: false
    }
  },
  {
    path: '/educationBuild',
    name: 'educationBuild',
    component: () => import('../views/warehouse/build/educationBuild.vue'),
    meta: {
      selectFlag: true,
      requireVip: false
    }
  },
  {
    path: '/educationPreview',
    name: 'educationPreview',
    component: () => import('../views/preview/educationPreview.vue'),
    meta: {
      selectFlag: true,
      requireVip: false,
      visibleShrinkUnfold: true
    }
  },
  {
    path: '/educationTransferPage/seeWarehouse',
    name: 'seeWarehouse',
    component: () => import('../views/educationTransferPage/seeWarehouse.vue'),
    meta: {
      selectFlag: true,
      requireVip: false
    }
  },
  {
    path: '/flowSheet',
    name: 'flowSheet',
    component: () => import('../views/warehouse/bpmn_flowSheet/index.vue'),
    meta: {
      selectFlag: true,
      visibleShrinkUnfold: false
    }
  },
  {
    path: '/digitBoard',
    name: 'digitBoard',
    component: () => import('../views/digitBoard/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: true,
      visibleShrinkUnfold: false
    }
  },
  {
    path: '/pickingHeatmap',
    name: 'pickingHeatmap',
    component: () => import('../views/pickingHeatmap/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: false
    }
  },
  {
    path: '/stocktakingTask',
    name: 'stocktakingTask',
    component: () => import('../views/stocktakingTask/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: false
    }
  },
  {
    path: '/simulation',
    name: 'simulation',
    component: () => import('../views/simulation/index.vue'),
    meta: {
      selectFlag: true,
      requireVip: true
    }
  },
  { path: '*', redirect: '/login' }
]

const router = new VueRouter({
  mode: 'hash',
  routes
})

// 路由守卫，拦截（当用户过期，就不能跳转到出登录的其它页面）
router.beforeEach(async (to, from, next) => {
  //到达路由需要Vip
  if (to.meta.requireVip) {
    if (check.isVip()) {
      next()
    } else {
      const res = await getViewWarehouseList()
      //打开续费弹窗
      if (res.data.rows.length) {
        next(false)
      } else {
        next()
      }
      openAlertConfirm()
    }
  } else {
    next()
  }
})

async function openAlertConfirm() {
  if (!getToken()) {
    return
  }
  let alertData = {
    type: '续费提醒',
    showClose: false,
    center: false,
    contentTextSize: '14px',
    clickModalClose: false,
    btnWidth: '80px',
    contentMargin: '5px 0 10px 0',
    textAlign: 'center',
    msg: '您的账号已过期，我们将限制部分功能，请及时续费',
    btn: {
      ok: '续费',
      no: '忽略'
    }
  }
  const res = await getViewWarehouseList()
  if (res.data.rows.length == 0) {
    delete alertData.btn.no
  }
  alertConfirm(alertData)
    .then(() => {
      router.push({
        path: './myWarehouse',
        query: {
          type: 'pay'
        }
      })
    })
    .catch(() => {
      // router.push('./previewPlay')
    })
}

export default router
